export const TOKEN_DECIMALS = {
  USDT:   Number(import.meta.env.VITE_USDT_DECIMALS   ?? 6),
  TAKARA: Number(import.meta.env.VITE_TAKARA_DECIMALS ?? 9),
  LAIKA:  Number(import.meta.env.VITE_LAIKA_DECIMALS  ?? 9),
}

export const USDT_MULT   = Math.pow(10, TOKEN_DECIMALS.USDT)
export const TAKARA_MULT = Math.pow(10, TOKEN_DECIMALS.TAKARA)
